// @flow

import React from 'react';
import moment from 'moment';

type Props = {
  title: string,
  subtitle: ?string,
  info: ?string,
  infoIsDate?: boolean,
  selected: ?boolean,
  onClick: ?() => void,
  id: ?number,
  isOpeningStore: ?boolean,
}

function Stepper({ title, subtitle, info, selected, onClick, id, infoIsDate, isOpeningStore }: Props) {
  return (
    <div className={`stepper stepper--${selected}`} key={id}>
      <div className="stepper-step">
        {
          isOpeningStore
            ? <i className="fas fa-store stepper-store" />
            : <div className="stepper-round" />
        }

        <div className="stepper-line" />
      </div>
      <div className="stepper-text" onClick={!!onClick && onClick}>
        <div className="stepper-title">{title}</div>
        {
          subtitle
          && (
            <div className="stepper-subtitle">{subtitle}</div>
          )
        }
        {
          info && (
            <div className="stepper-info">
              {
                infoIsDate ? moment(info).format('MMMM Do YYYY, h:mm:ss a') : info
              }
            </div>
          )
        }
      </div>
    </div>
  );
}

Stepper.defaultProps = {
  infoIsDate: false,
};

export default Stepper;
